// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationAssetClassesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IntegrationAssetClassesQuery = { __typename?: 'Query', integrationAssetClasses: { __typename?: 'IntegrationAssetClassConnection', edges?: Array<{ __typename?: 'IntegrationAssetClassEdge', node?: { __typename?: 'IntegrationAssetClass', id: string, integrationName: string, provider: Types.IntegrationAssetClassProvider, assetClass?: { __typename?: 'AssetClass', id: string } | null } | null } | null> | null } };

export type BalanceSheetCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BalanceSheetCategoriesQuery = { __typename?: 'Query', balanceSheetCategories: { __typename?: 'BalanceSheetCategoryConnection', edges?: Array<{ __typename?: 'BalanceSheetCategoryEdge', node?: { __typename?: 'BalanceSheetCategory', id: string, displayName: string, type: Types.BalanceSheetCategoryType } | null } | null> | null } };

export const Operations = {
  Query: {
    IntegrationAssetClasses: 'IntegrationAssetClasses' as const,
    BalanceSheetCategories: 'BalanceSheetCategories' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const IntegrationAssetClassesDocument = gql`
    query IntegrationAssetClasses {
  integrationAssetClasses {
    edges {
      node {
        id
        integrationName
        provider
        assetClass {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useIntegrationAssetClassesQuery__
 *
 * To run a query within a React component, call `useIntegrationAssetClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationAssetClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationAssetClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationAssetClassesQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>(IntegrationAssetClassesDocument, withFetchPolicyContext(options));
      }
export function useIntegrationAssetClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>(IntegrationAssetClassesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useIntegrationAssetClassesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>(IntegrationAssetClassesDocument, withFetchPolicyContext(options));
        }
export type IntegrationAssetClassesQueryHookResult = ReturnType<typeof useIntegrationAssetClassesQuery>;
export type IntegrationAssetClassesLazyQueryHookResult = ReturnType<typeof useIntegrationAssetClassesLazyQuery>;
export type IntegrationAssetClassesSuspenseQueryHookResult = ReturnType<typeof useIntegrationAssetClassesSuspenseQuery>;
export type IntegrationAssetClassesQueryResult = Apollo.QueryResult<IntegrationAssetClassesQuery, IntegrationAssetClassesQueryVariables>;
export const BalanceSheetCategoriesDocument = gql`
    query BalanceSheetCategories {
  balanceSheetCategories(where: {typeNotIn: [INSURANCE]}) {
    edges {
      node {
        id
        displayName
        type
      }
    }
  }
}
    `;

/**
 * __useBalanceSheetCategoriesQuery__
 *
 * To run a query within a React component, call `useBalanceSheetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceSheetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceSheetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceSheetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>(BalanceSheetCategoriesDocument, withFetchPolicyContext(options));
      }
export function useBalanceSheetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>(BalanceSheetCategoriesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useBalanceSheetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>(BalanceSheetCategoriesDocument, withFetchPolicyContext(options));
        }
export type BalanceSheetCategoriesQueryHookResult = ReturnType<typeof useBalanceSheetCategoriesQuery>;
export type BalanceSheetCategoriesLazyQueryHookResult = ReturnType<typeof useBalanceSheetCategoriesLazyQuery>;
export type BalanceSheetCategoriesSuspenseQueryHookResult = ReturnType<typeof useBalanceSheetCategoriesSuspenseQuery>;
export type BalanceSheetCategoriesQueryResult = Apollo.QueryResult<BalanceSheetCategoriesQuery, BalanceSheetCategoriesQueryVariables>;